'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
export default class RawAsset extends ImmutableModel {
  constructor(props) {
    return super(props);
  }

}